/* @flow */

export const dimmed = Symbol();
